var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteFlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1011_3482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.148438,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1011_3482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 17.4819V14.8153H9.33334V17.4819H1.33334ZM10.3333 12.3486L7.53334 9.5486L9.40001 7.68193L12.2 10.4819L10.3333 12.3486ZM14.6667 9.48193V1.48193H17.3333V9.48193H14.6667ZM21.6667 12.3486L19.8 10.4819L22.6 7.68193L24.4667 9.5486L21.6667 12.3486ZM22.6667 17.4819V14.8153H30.6667V17.4819H22.6667ZM16 20.1486C14.8889 20.1486 13.9445 19.7597 13.1667 18.9819C12.3889 18.2042 12 17.2597 12 16.1486C12 15.0375 12.3889 14.093 13.1667 13.3153C13.9445 12.5375 14.8889 12.1486 16 12.1486C17.1111 12.1486 18.0556 12.5375 18.8333 13.3153C19.6111 14.093 20 15.0375 20 16.1486C20 17.2597 19.6111 18.2042 18.8333 18.9819C18.0556 19.7597 17.1111 20.1486 16 20.1486ZM22.6 24.6153L19.8 21.8153L21.6667 19.9486L24.4667 22.7486L22.6 24.6153ZM9.40001 24.6153L7.53334 22.7486L10.3333 19.9486L12.2 21.8153L9.40001 24.6153ZM14.6667 30.8153V22.8153H17.3333V30.8153H14.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFlare);
export default __webpack_public_path__ + "static/media/white_flare.9e1683f7e086917311f27645d2bb7ff6.svg";
export { ForwardRef as ReactComponent };